import { Action } from "redux";

export type AuthChangePerspective = "AUTH_CHANGE_PERSPECTIVE";
export const AUTH_CHANGE_PERSPECTIVE: AuthChangePerspective = "AUTH_CHANGE_PERSPECTIVE";

export interface AuthChangePerspectiveAction extends Action {
    type: AuthChangePerspective;
    payload: {
        asUser: boolean;
    };
}

export function authChangePerspective(asUser: boolean): AuthChangePerspectiveAction {
    return {
        payload: {
            asUser
        },
        type: AUTH_CHANGE_PERSPECTIVE
    };
}